/// <reference path="../../BaseNew/GAdmHromadnaOperaceBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class HromadnaOperaceVlastnostObecnyObjekt extends GContentBase {
        private hromadnaOperaceObj: HromadnaOperaceVlastnostObecnyObjektObj & GContent;
        private data: Gordic.AdmIsl.Interface.GAdmVlastnostObecnyObjektReadDto[];
        private keys: string[];

        onContentReady() {
            this.hromadnaOperaceObj = $.extend(this as GContent, new HromadnaOperaceVlastnostObecnyObjektObj())
            this.hromadnaOperaceObj.createBase({
                title: "jres:33000492",
                data: this.data,
                objectFields: ['objekt_nazev'],
                serviceCnt: "Gordic.Adm.WebControls.HromadnaOperaceVlastnostObecnyObjekt",
                keys: this.keys,
                contentId: "hromadnaOperaceVlastnostObecnyObjekt"
            })
        }
    }

    export class HromadnaOperaceVlastnostObecnyObjektObj extends GAdmHromadnaOperaceBase<Gordic.AdmIsl.Interface.GAdmVlastnostObecnyObjektReadDto> {
        ico: string;
        isPovolenoPoradi: boolean;

        createForm(cnt: GContent<IGContentBase, any>, contentDiv: JQuery<HTMLElement>, change: OGWizardChange) {
            var form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1" })
                .addRow("jres:33000095").addField("gselectbox", Gordic.Prefabs.Select.ekosico(), {
                    model: "model.ico=value.ico",
                    name: "ico",
                    initialValue: { ico: this.ico },
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    disabled: true,
                })
                .addRow("jres:29929518").addField("gselectbox", Gordic.Prefabs.Select.admGincobj(), {
                    model: "model.typ_obj=value.typ_obj",
                    name: "typ_obj",
                    initialValue: { typ_obj: this.options.data[0].typ_obj },
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    disabled: true,
                })
            this.createObjectSelectBox(form).addRow("jres:33000455").addField("gselectbox", Gordic.Prefabs.Select.admGinvovp(), {
                    model: "model.typ_vps=value.typ_vps;model.ixs=value.ixs;model.ico=value.ico;model.typ_obj=value.typ_obj;model.nazev<=value.nazev;model.typ_vps_txt<=value.typ_vps_txt",
                    dropdown: false,
                    multi: true,
                    serverFilters: {
                        ico: new Gordic.Forms.Dependency("ico", "ico", true, false, contentDiv),
                        typ_obj: new Gordic.Forms.Dependency("typ_obj", "typ_obj", true, false, contentDiv),
                        aktivita: 100
                    },
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                })
                .addRow("jres:32131030").addField("gselectbox", Gordic.Prefabs.Select.gincakt(), {
                    name: "aktivita",
                    model: "model.aktivita=value.aktivita;model.aktivita_txt<=value.aktivita_txt",
                    initialValue: { aktivita: 100 },
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                })
            $("<div>").appendTo(contentDiv).gform("createFrom", form);
        }

        createDefineGridData(formData: any): any {
            var cartesianResult = this.createCartesianProduct2D(this.transformDataToArrayObject(formData, ["sxs", "objekt_nazev"]), this.transformDataToArrayObject(formData, ["ixs", "typ_vps", "typ_vps_txt", "nazev"]));
            var resultArray: any = [];
            var poradi = 0;
            cartesianResult.forEach((item) => {
                poradi = resultArray.filter(obj => obj.sxs == item[0]["sxs"]).length + 1;
                var data = {
                    sxs: item[0]["sxs"],
                    objekt_nazev: item[0]["objekt_nazev"],
                    ixs: item[1]["ixs"],
                    typ_vps: item[1]["typ_vps"],
                    typ_vps_txt: item[1]["typ_vps_txt"],
                    nazev: item[1]["nazev"],
                    aktivita: formData['aktivita'],
                    ico: formData['ico'][0],
                    typ_obj: formData['typ_obj'][0]
                }
                if (this.isPovolenoPoradi == true)
                    data["poradi"] = poradi;
                resultArray.push(data);
            })
            return resultArray;
        }

        createGridFormat(gridFormat: Gordic.Data.GridFormat): Gordic.Data.GridFormat {
            this.createAktivitaColumn(gridFormat);
            gridFormat.addTextColumn({
                caption: "jres:33000095",
                name: "ico",
            }).addTextColumn({
                caption: "jres:33000403",
                name: "objekt_nazev",
            }).addTextColumn({
                caption: "jres:29932138",
                name: "typ_vps_txt",
            }).addTextColumn({
                caption: "jres:32131029",
                name: "nazev",
            })
            if (this.isPovolenoPoradi == true)
                gridFormat.addNumberColumn({
                    caption: "jres:30029253",
                    name: "poradi",
                    editor: {
                        widget: "gnumberbox",
                        options: {
                            validators: [
                                new Gordic.Validators.Required({ stopping: true }),
                                new Gordic.Validators.Range({ min: 1, max: 32767, stopping: true })
                            ]
                        }
                    }
                })
            return gridFormat;
        }

        // Volání zatím přes CSharp (přes ISL zatím nevím jak na hromadné operace)
        saveData(data: any[]): JQueryPromise<any> {
            var saveData: Gordic.AdmIsl.Interface.GAdmVlastnostObecnyObjektSaveDto[] = [];
            data.forEach((item) => {
                saveData.push({
                    sxs: item['sxs'],
                    ixs: item['ixs'],
                    typ_obj: item['typ_obj'],
                    ico: item['ico'],
                    typ_vps: item['typ_vps'],
                    aktivita: item['aktivita'],
                    poradi: this.isPovolenoPoradi == true ? item['poradi'] : null,
                    NewRecord: true
                })
            })
            return this.getServiceCnt().call("SaveHromadne", { saveData: saveData }).done((results) => {
                this.createResultData(results)
            })
        }

        validateRows(data: any): Gordic.Validators.GridError[] {
            return [];
        }

        testExistMethod(data: any[]): JQueryPromise<any> {
            return $.Deferred()
        }
    }
}